{
	"loginPage": {
		"title": "Log in",
		"title2": "Welcome back",
		"subtitle": "Send, receive and return. All in the same place.",
		"subtitle2": "Enter your password to log in as:",
		"form": {
			"email": "Email",
			"placeholder_email": "name@example.com",
			"password": "Password",
			"placeholder_password": "**************",
			"checkbox": "Remember my information",
			"forgetPassword": "I forgot my password",
			"btnLogin": "Log in",
			"btnGoogle": "Continue with Google",
			"btnFacebook": "Continue with Facebook",
			"footer": "New to Fullfillment?",
			"footerLink": "We can help you"
		},
		"errors": {
			"emailInvalid": "Please enter a valid email address.",
			"passwordInvalid": "Please enter a valid password."
		},
		"alert": {
			"code-1202": {
				"msgTitle": "An error occurred",
				"msgSubtitle": "Invalid username or incorrect password"
			}
		},
		"buttons": {
			"continue": "Continue",
			"create-account": "Don't have an account? Sign up."
		},
		"links": {
			"forgot-password": "Forgot my password",
			"terms-and-conditions": "Terms and conditions"
		}
	},
	"inputs": {
		"phone": {
			"title": "Phone",
			"placeholder": "XXXXXXXXXX"
		},
		"search": {
			"title": "Search..."
		}
	},
	"createNewAccount": {
		"title": "Create an account",
		"subtitle": "Welcome! To create an account, please add the following information. This is important to validate that your shipments belong to you.",
		"form": {
			"first_name": "First name(s)",
			"errorMessageFirstName": "Please enter your name",
			"placeholder_first_name": "John",
			"last_name": "Last name",
			"errorMessageLastName": "Please enter your last name",
			"placeholder_last_name": "Doe",
			"btnLogin": "Log in",

			"alert": "By continuing, you agree to our",
			"&": "and",
			"termsAndConditions": "Terms and Conditions",
			"privacyPolicy": "Privacy Policy"
		},
		"dialog": {
			"code-invitation": {
				"title": "Property code",
				"subtitle": "Enter your code to continue. If you don't have it, request it from the administration",
				"buttons": {
					"cancel": "Cancel",
					"confirm": "Confirm"
				},
				"error": {
					"codeIncorrect": "The code you entered is incorrect. Please ask the administrator for it.",
					"errorOnlyLetters": "Only letters and spaces are allowed."
				}
			},
			"email-verification": {
				"title": "Verify your email to continue",
				"subtitle": "We sent a 6-digit security code to",
				"buttons": {
					"resend": "Resend",
					"confirm": "Confirm"
				},
				"error": {
					"codeExpired": "The code you entered has expired. Try again.",
					"codeIncorrect": "The code you entered is incorrect. Please ask the administrator for it."
				},
				"button": {
					"resend": "Resend",
					"confirm": "Confirm"
				}
			}
		},
		"buttons": {
			"continue": "Continue"
		}
	},
	"identifyUnit": {
		"title": "Identify this unit",
		"subtitle": "Add the unit code to continue",
		"inputs": {
			"title": "Unit",
			"placeholder": "Please enter your unit or apartment number"
		},
		"errors": {
			"unitError": "The unit must contain at least 1 character",
			"unitNotFound": "Unit not found, please check with your administrator."
		},
		"buttons": {
			"continue": "Continue"
		}
	},
	"setEmail": {
		"title": "Almost there! Now enter your email",
		"subtitle": "This way we can notify you when your packages arrive in our lockers",
		"inputs": {
			"title": "Email",
			"placeholder": "name@example.com"
		},
		"buttons": {
			"continue": "Continue"
		}
	},
	"setPasswordToAccount": {
		"title": "Lastly, create a password",
		"subtitle": "Complete the following steps to create a secure password.",
		"inputs": {
			"newPassword": {
				"title": "Your new password",
				"placeholder": "Enter password"
			},
			"confirmPassword": {
				"title": "Confirm password",
				"placeholder": "Enter password"
			}
		},
		"validations": {
			"titleValidations": "Your password must meet the following requirements:",
			"validation0": "One lowercase letter",
			"validation1": "One uppercase letter",
			"validation2": "One number",
			"validation3": "One special character",
			"validation4": "At least 8 characters"
		},
		"buttons": {
			"continue": "Continue"
		}
	},
	"createNewPassword": {
		"forgotPasswordForm": {
			"title": "I forgot my password",
			"subtitle": "Don't worry, it happens to everyone. Enter the email associated with your account and we’ll tell you how to recover it.",
			"email": "Email",
			"recoverPassword": "Recover my password",
			"buttonThrowback": "Back to main screen"
		},
		"title": "Create a new password",
		"subtitle": "Complete the following fields and recover your account so you can keep sending your products.",
		"form": {
			"labelNewPassword": "Your new password",
			"boxValidation": {
				"title": "To protect your account, make sure your password has:",
				"validation1": "One uppercase letter",
				"validation2": "One number",
				"validation3": "One special character",
				"validation4": "At least 8 characters"
			},
			"confirmPassword": "Confirm your password",
			"btnUpdatePassword": "Update my password"
		},
		"passwordChanged": {
			"title": "All set!",
			"subtitle": "We knew you’d be back. You’ve recovered your account and can now continue managing your logistics network with us."
		},
		"passwordNotChanged": {
			"title": "Oops, an error occurred!",
			"subtitle": "We're sorry about this. Please try the password change process again."
		},
		"oneStepMore": {
			"title": "Just one more step...",
			"subtitle-1": "If the email",
			"subtitle-2": "is associated with an account, you will receive an email with the next steps. Make sure to check your spam or junk folder.",
			"paragraph-1": "Not sure about the email you entered?",
			"paragraph-2": "Try a different one."
		},
		"buttons": {
			"throwback-login": "Go to main screen",
			"updatePassword": "Update my password",
			"sendEmail": "Resend email",
			"returnBackLogin": "Back to main screen"
		},
		"notifications": {
			"emailSending": {
				"title": "Email re-sent",
				"subtitle": "Check your spam or junk folder. If you still don’t receive it, verify that your email is written correctly."
			}
		}
	},
	"page403": {
		"title": "Error 403",
		"subtitle": "Access Denied",
		"paragraph": "It seems you don't have permission to view this page. Please try accessing again, and if this error persists, feel free to contact us. We’ll help you resolve it."
	},
	"page404": {
		"title": "Error 404",
		"subtitle": "Page unavailable",
		"paragraph": "We couldn’t find what you were looking for. Try refreshing the page or go back to the home page."
	},
	"page500": {
		"title": "Error 500",
		"subtitle": "Page unavailable",
		"paragraph": "It seems we’ve encountered a problem, but don’t worry. Try refreshing the page or return to the home page."
	},
	"page503": {
		"title": "Error 503",
		"subtitle": "This service is unavailable",
		"paragraph": "The service you are trying to access is not available right now. Try refreshing the page or return to the home page."
	},
	"estatus": {
		"RECOLECTADO": "Collected",
		"RETURN": "Returned",
		"ENTREGADO": "Delivered",
		"SCHEDULED": "Scheduled",
		"PENDIENTE": "Pending",
		"EXPIRED": "Expired",
		"EXTENDED": "Extended",
		"LOCKER": "In Locker",
		"CANCELED": "Canceled",
		"CANCELED_LOCKER": "Canceled In Locker",
		"CANCELED_PICKED": "Canceled Picked Up",
		"PASSWORD_EXPIRADO": "Password Expired",
		"ACTIVE": "Active",
		"DESACTIVE": "Inactive",
		"PackageCollected": "Package Collected",
		"PackageInLocker": "Package In Locker",
		"PackageExpired": "Package Expired",
		"Warehouse": "In Warehouse",
		"ScheduledDoor": "Scheduled Door",
		"OpenDoor": "Door Open",
		"CloseDoor": "Door Closed",
		"FailDoor": "Door Failure",
		"BusyDoor": "Door Busy",
		"loginSuccess": "Login Success",
		"loginError": "Login Attempt",
		"useMasterCode": "Master Code Used",
		"logout": "Log out"
	},
	"common": {
		"no_data_available": "No data available"
	},
	"alerts": {
		"userRegistered": {
			"title": "User already registered",
			"subtitle": "Please verify with your administrator"
		},
		"invalidCode": {
			"title": "Invalid code",
			"subtitle": "Please resend the email and enter the correct code"
		},
		"emailRegistered": {
			"title": "Email or Telephone already registered",
			"subtitle": "Check your credentials or try recovering your password"
		},

		"code-1202": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Invalid username or incorrect password"
		},
		"code-1500": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Duplicate data found"
		},
		"code-1501": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Unexpected server response"
		},
		"code-1518": {
			"msgTitle": "User not found",
			"msgSubtitle": "Please verify if the email or password is correct"
		},
		"code-1502": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Error saving the company and branches"
		},
		"code-9999": {
			"msgTitle": "Invalid credentials",
			"msgSubtitle": "User or password is invalid"
		}
	},
	"input-alerts": {
		"code-1518": {
			"email": "Incorrect email",
			"password": "Incorrect password"
		}
	},
	"homePage": {
		"title": "Hello,",
		"activity": "Actividad",
		"availableService": {
			"title": "Available services",
			"options": {
				"schedulePackage": {
					"title": "Schedule Package",
					"subtitle": "Schedule the delivery of your packages"
				},
				"rentCompartment": {
					"title": "Rent compartment",
					"subtitle": "Rent a compartment for as long as you need"
				},
				"shareCompartment": {
					"title": "Share compartment",
					"subtitle": "Share your compartment with family and friends"
				},
				"scheduledCompartment": {
					"title": "Schedule compartment",
					"subtitle": "Reserve a compartment for future use"
				}
			}
		},
		"cards": {
			"card1": {
				"title": "In locker",
				"tooltip": "Packages entered since the user's creation",
				"footer": "Packages in locker"
			},
			"card2": {
				"title": "Delivered",
				"tooltip": "Packages delivered since the user's first session",
				"footer": "Delivered packages"
			},
			"card3": {
				"title": "Scheduled",
				"tooltip": "Packages scheduled by the user",
				"footer": "Scheduled packages"
			},
			"card4": {
				"title": "Recent",
				"tooltip": "Packages that recently entered the locker",
				"footer": "Recent packages"
			}
		},
		"overlay": {
			"noRows": {
				"inLocker": {
					"title": "Nothing here...",
					"subtitle": "This table shows the orders in the locker and information about them."
				},
				"completed": {
					"title": "Nothing here...",
					"subtitle": "This table shows the completed orders and information about them."
				},
				"schedule": {
					"title": "Nothing here...",
					"subtitle": "This table shows the scheduled orders and information about them."
				},
				"recent": {
					"title": "Nothing here...",
					"subtitle": "This table shows the most recent orders and information about them."
				}
			}
		},
		"contentSwitcher": {
			"inLocker": "In locker",
			"completed": "Completed",
			"scheduled": "Scheduled",
			"recent": "Recent"
		},
		"table": {
			"common": {
				"order_number": "Order\nnumber",
				"tracking_number": "Tracking",
				"locker_name": "Locker",
				"days_to_expire": "Days to\nexpire",
				"registration_date": "Registration date",
				"expiration_date": "Expiration date"
			},
			"inlocker": {
				"tracking_number": "Tracking",
				"otp": "OTP",
				"is_a_favor": "Is it a favor?",
				"locker_name": "Locker",
				"status": "Status",
				"registration_date": "Registration date",
				"expiration_date": "Expiration date"
			},
			"completed": {
				"tracking_number": "Tracking",
				"hash_package": "HashPackage",
				"is_a_favor": "Is it a favor?",
				"locker_name": "Locker",
				"status": "Status",
				"registration_date": "Registration\ndate",
				"package_pickup_date": "Pickup\ndate"
			},
			"schedule": {
				"code_service": "Service code",
				"is_a_favor": "Is it a favor?",
				"locker_name": "Locker",
				"otp": "OTP",
				"status": "Status"
			},
			"recent": {
				"tracking_number": "Tracking",
				"order_number": "Order\nnumber",
				"locker_name": "Locker",
				"otp": "OTP",
				"hash_package": "HashPackage",
				"status": "Status",
				"days_to_expire": "Days to\nexpire",
				"registration_date": "Registration\ndate",
				"expiration_date": "Expiration\ndate"
			}
		},
		"isAFavor": {
			"no": "No",
			"yes": "Yes"
		},
		"status": {
			"IN_LOCKER": "In locker",
			"EXPIRED_IN_LOCKER": "Expired in locker",
			"COMPLETED": "Completed",
			"SCHEDULED": "Scheduled",
			"EXPIRED_COLLECTED": "Returned"
		},
		"myPackages": {
			"title": "My packages"
		}
	},
	"orderDetailPage": {
		"back": "My account details",
		"cancelPackage": "Cancel service",
		"qrDetail": {
			"scheduled": {
				"text": "You will find your pickup code here when your package is delivered to the locker."
			},
			"expiredInLocker": {
				"title": "Unfortunately, your package has expired",
				"text": "What to do in these cases?",
				"loading": "Generating code..."
			},
			"inLocker": {
				"title": "Pickup code",
				"loading": "Generating code..."
			},
			"completed": {
				"title": "Package successfully collected",
				"text": "Find more important information about your package here"
			},
			"expiredCompleted": {
				"title": "Expired package successfully collected",
				"text": "Find more important information about your package here"
			}
		},
		"informatioPackage": {
			"packageDetail": {
				"title": "Package Information",
				"subtitle": "Shipping details and locker location.",

				"fields": {
					"tracking_number": "Tracking number",
					"locker_name": "Locker",
					"otp": "OTP",
					"is_a_favor": "Is it a favor?",
					"order_number": "Order number",
					"registration_date": "Registration date",
					"expiration_date": "Expiration date",
					"package_pickup_date": "Pickup\ndate",
					"status": "Status"
				},
				"status": {
					"IN_LOCKER": "In locker",
					"COMPLETED": "Completed",
					"EXPIRED_COLLECTED": "Returned",
					"EXPIRED_IN_LOCKER": "Expired",
					"SCHEDULED": "Scheduled"
				}
			},
			"userDetails": {
				"title": "User Information",
				"subtitle": "Personal details and registered location.",
				"fields": {
					"full_name": "Full name",
					"vivi-id": "VIVI-ID",
					"email": "Email",
					"unity": "Unit",
					"address": "Location"
				}
			}
		},
		"manualToRecolect": {
			"title": "Don’t know how to collect?",
			"subtitle": "Learn how to collect your packages",
			"button": "How does it work?"
		},
		"manualToPickUp": {
			"title": "How to collect your package?",
			"list": {
				"option1": "Complete the payment to obtain your pickup code.",
				"option2": "Go to the locker where your package is located.",
				"option3": "Scan the pickup code to open the door.",
				"option4": "Pick up your package and close the door when finished."
			}
		},
		"transactionDetail": {
			"title": "Transaction details",
			"details": {
				"expirationFee": "Expiration fee",
				"perday": "per day",
				"administrationFee": "Administration fee",
				"totalValue": "of the total value",
				"subtotal": "Subtotal",
				"total": "Total"
			},
			"alert": {
				"urlError": {
					"title": "We couldn't generate payment link",
					"subtitle": "Please try again or contact the administrator."
				},
				"error": {
					"title": "Payment processing error",
					"subtitle": "There was a problem communicating with the server."
				}
			}
		},
		"buttons": {
			"title": "Continue with payment"
		}
	},
	"schedulePackagePage": {
		"title": "Register a package",
		"details": {
			"title": "Enter the following information to continue",
			"whichProperty": "Which property will you receive at?",
			"changeLocation": "Change location",
			"fields": {
				"tracking_number": "Tracking number",
				"haveOtp": "Does your package have an OTP?"
			},
			"buttons": {
				"continue": "Continue",
				"cancel": "Cancel"
			}
		}
	},
	"preferences": {
		"appartment": "Apartment",
		"notifications": {
			"title": "Don’t miss your notifications!",
			"subtitle": "Add your phone number to receive notifications on WhatsApp"
		},
		"account": {
			"title": "Account",
			"fields": {
				"details": "My account details",
				"notifications": "Notifications",
				"lockerPreferences": "Locker preferences",
				"Appearance": "Appearance"
			},
			"details": {
				"title": "My account details",
				"subtitle": "Review and manage your personal information",
				"fields": {
					"username": "Name",
					"lastname": "Last name",
					"email": "Email",
					"main_tlf": "Phone number",
					"subtitle_main_tlf": "Required to enable WhatsApp notifications"
				},
				"chip": {
					"edit": "Edit"
				},
				"alerts": {
					"200": {
						"title": "Profile updated",
						"subtitle": "Your information was successfully saved"
					},
					"400": {
						"title": "Incomplete fields",
						"subtitle": "Please review the highlighted fields before continuing"
					},
					"401": {
						"title": "Session expired",
						"subtitle": "For security reasons, please log in again"
					},
					"500": {
						"title": "Unexpected error",
						"subtitle": "Something went wrong while updating your information"
					}
				},
				"buttons": {
					"edit": "Edit my information",
					"changePassword": "Change my password",
					"save": "Save changes",
					"cancel": "Cancel"
				},
				"verifyTelephone": {
					"title": "Verify phone",
					"subtitle": "Enter your number to receive a verification code via SMS",
					"alert": {
						"title": "Secure verification",
						"subtitle": "We will send you a 6-digit code via SMS. The number will not be saved until it has been successfully verified."
					},
					"input": {
						"title": "Phone Number",
						"footer": "Include the country code (e.g., +52 for Mexico)"
					},
					"buttons": {
						"sendCode": "Send code",
						"cancel": "Cancel"
					},
					"success": {
						"title": "Success! The phone has been assigned",
						"subtitle": "Now the user can activate their WhatsApp notifications"
					},
					"put-telephone": {
						"title": "You must enter a phone number",
						"subtitle": "A phone number is required to receive notifications"
					},
					"dialog": {
						"title": "To continue, verify your phone number",
						"subtitle": "We sent a 6-digit security code to ",
						"edit": "Edit my number",
						"error": {
							"expiredCode": "The code you entered has expired. Please try again"
						},
						"buttons": {
							"verified": "Verify",
							"resend": "Resend code"
						}
					}
				}
			},
			"notifications": {
				"mainTitle": "Notifications",
				"title": "System notifications",
				"subtitle": "These notifications will be sent when we have updates about your orders",
				"channels": "Channels",
				"systemRequirements": "System Requirements",
				"options": {
					"push": "Push",
					"email": "Email",
					"subtitleEmail": "Delivery confirmations and pickup reminders",
					"whatsapp": "WhatsApp",
					"subtitleWhatsapp": "Real-time alerts and locker access codes"
				},
				"alert": {
					"notificationActivatedEmail": {
						"title": "Notification enabled",
						"subtitle": "We will send you emails with important information."
					},
					"notificationDesactivatedEmail": {
						"title": "Notification disabled",
						"subtitle": "We will not send you emails."
					},
					"notificationActivatedWhatsapp": {
						"title": "WhatsApp notifications enabled",
						"subtitle": "We will send you WhatsApp messages with important information."
					},
					"activateWhatsapp": {
						"title": "Please activate your phone number first",
						"subtitle": "This is required so you can receive WhatsApp messages."
					},
					"notificationDesactivatedWhatsapp": {
						"title": "WhatsApp notifications disabled",
						"subtitle": "We will not send you WhatsApp messages."
					}
				}
			},
			"preferencesLocker": {
				"title": "Locker preferences",
				"mainTitle": "Accessibility options",
				"mainSubtitle": "Set up the service your way",
				"lowerDoors": {
					"title": "Receive in lower doors",
					"subtitle": "Allow your packages to be assigned to lower compartments of the locker."
				},
				"setVacationPeriod": {
					"title": "Set vacation period",
					"subtitle": "Perfect for when you travel or will be away for a few days"
				},
				"selectVacationPeriod": {
					"title": "Select your vacation period",
					"subtitle": "Choose what will happen to your packages while you're away"
				},
				"vacation": {
					"initPeriod": "Start date",
					"endPeriod": "Return date",
					"happendToMyPackage": "What will happen to my packages?"
				},
				"buttons": {
					"edit": "Edit vacation period",
					"delete": "Delete vacation period"
				},
				"alert": {
					"downCompartmentActivated": {
						"title": "Lower compartments enabled",
						"subtitle": "Your packages will be placed only in lower compartments"
					},
					"downCompartmentDesactivated": {
						"title": "Lower compartments disabled",
						"subtitle": "Your packages will be placed in any compartment"
					},
					"HolidaysInitiated": {
						"title": "Vacations not created",
						"subtitle": "You cannot modify vacations that have already started"
					},
					"HolidaysEdited": {
						"title": "Vacations edited",
						"subtitle": "The vacations have been updated"
					},
					"HolidaysNotCreated": {
						"title": "Vacations not created",
						"subtitle": "You have exceeded the vacation creation limit"
					},
					"HolidaysCreated": {
						"title": "Vacations created",
						"subtitle": "The holidays have been added."
					}
				},
				"dialog": {
					"confirm-delete-vacations": {
						"title": "Cancel vacation period",
						"subtitle": "You are about to cancel this vacation period. By doing so:",
						"list": {
							"li-1": "Your packages will be managed normally again",
							"li-2": "This period will still count as one of your 3 available periods for the year, even if you cancel it"
						},
						"paragraph": "Are you sure you want to continue? This action cannot be undone",
						"buttons": {
							"delete": "Yes, cancel vacation period",
							"cancel": "Cancel"
						}
					}
				}
			},
			"vacationPeriod": {
				"mainTitle": "Vacation period",
				"title": "Set your away time",
				"subtitle": "You can activate up to 3 periods per year, with a maximum of 2 weeks each.",
				"calendar": {
					"subtitle": "Decide what will happen to your packages during your away period.",
					"initPeriod": "Start date",
					"endPeriod": "Return date",
					"happendToMyPackage": "What will happen to my packages?"
				},
				"buttons": {
					"cancel": "Cancel",
					"save": "Save changes"
				},
				"options": {
					"first": {
						"title": "Keep them in the locker",
						"subtitle": "Once your packages enter the locker, they will remain there until this period ends. Subject to availability at the time of delivery."
					},
					"second": {
						"title": "Allow someone else to pick them up",
						"subtitle": "During your absence, your packages can still arrive and be picked up by someone else. Ideal if a trusted person can help you."
					},
					"third": {
						"title": "Pause deliveries",
						"subtitle": "Your locker deliveries will be paused, preventing accumulation and helping keep everything under control while you're away."
					}
				}
			},
			"appearence": {
				"mainTitle": "Appearance",
				"title": "Choose your preferred theme",
				"subtitle": "Select from preset themes or follow your system preferences.",
				"theme": {
					"light": "Light mode",
					"dark": "Dark mode"
				}
			},
			"changePassword": {
				"title": "Change Password",
				"subtitle": "Complete the following steps to switch to a secure password",
				"fields": {
					"actual_password": "Current Password",
					"new_password": "New Password",
					"confirm_password": "Confirm Password"
				},
				"buttons": {
					"continue": "Continue"
				},
				"alerts": {
					"code-200": {
						"title": "Password Changed",
						"subtitle": "The user has successfully changed the password"
					},
					"code-1202": {
						"title": "Password Not Changed",
						"subtitle": "The password was entered incorrectly"
					}
				}
			}
		},

		"support": {
			"title": "Support",
			"fields": {
				"helpCenter": "Help Center",
				"termsConditions": "Terms and Conditions",
				"about": "About",
				"delete": "Delete account"
			},
			"terms": {
				"title": "Terms and Conditions",
				"options": {
					"first": {
						"title": "1. Acceptance of the Terms",
						"subtitle": "By accessing or using the Package Delivery Application (hereinafter, “the Application”), you agree to comply with and be bound by these Terms of Service (hereinafter, “the Terms”). If you do not agree, you must not use the Application."
					},
					"second": {
						"title": "2. Service Description",
						"subtitle": "The Application offers package delivery services (hereinafter, “the Service”). Users can request pickup and delivery of packages through the Application within the enabled geographical areas."
					},
					"third": {
						"title": "3. Eligibility",
						"subtitle": "To use the Application, you must be at least 18 years old and have legal capacity to contract. By using it, you declare that you meet these requirements."
					},
					"four": {
						"title": "4. Account Registration",
						"subtitle": "To use the Service, you must create an account by providing accurate and complete information. You are responsible for maintaining the confidentiality of your account and password, and for notifying any unauthorized use."
					},
					"five": {
						"title": "5. Use of the Service",
						"list": {
							"deliveryRequest": {
								"title": "Delivery request:",
								"subtitle": "You can request a delivery by providing the necessary information, including addresses and a description of the package."
							},
							"restrictions": {
								"title": "Restrictions:",
								"subtitle": "The shipment of illegal, dangerous, or prohibited materials is not allowed. The Application may reject requests it considers inappropriate."
							},
							"ratesPayments": {
								"title": "Fees and Payments:",
								"subtitle": "You agree to pay all fees associated with the Service. Fees will be displayed before confirming your request. Payments are processed through the methods accepted by the Application."
							}
						}
					}
				}
			},
			"politicsAndPrivacy": {
				"title": "Privacy Policies",
				"options": {
					"first": {
						"title": "1. Acceptance of the Terms of Service",
						"subtitle": "By accessing or using the package delivery application (hereinafter, “the Application”), you agree to comply with and be bound by these Terms of Service (hereinafter, “the Terms”). If you do not agree with these Terms, you must not use the Application."
					},
					"second": {
						"title": "2. Description of the Service",
						"subtitle": "The Application provides package delivery services (hereinafter, “the Service”). Users may request the pickup and delivery of packages through the Application. The Service is available only in the geographic areas indicated within the Application."
					},
					"third": {
						"title": "3. Age and Legal Capacity Requirements",
						"subtitle": "To use the Application, you must be at least 18 years old and have the legal capacity to enter into contracts. By using the Application, you represent and warrant that you meet these requirements."
					}
				}
			},
			"about": {
				"title": "About the application",
				"subtitle": "Package Hub allows you to manage your package deliveries and pickups safely and easily. Thank you for being part of our community!",
				"table": {
					"title": "Application information",
					"items": {
						"nameAplication": "Application name",
						"version": "Version",
						"lastUpdate": "Last update"
					}
				}
			},
			"helpCenter": {
				"title": "Help Center",
				"pickupPackage": {
					"title": "How does it work?",
					"subtitle": "Pick up a package"
				},
				"phoneCall": {
					"title": "Request assistance",
					"subtitle": "Contact us"
				},
				"askedQuestion": {
					"title": "Frequently Asked Questions",
					"subtitle": "Find quick answers to your questions"
				},
				"securityIdentification": {
					"title": "Identification and Security",
					"subtitle": "VIVI-ID and security aspects that identify users at the lockers",
					"questions": {
						"q1": "What is the VIVI-ID and what is it for?",
						"q2": "How can I change my VIVI-ID?",
						"q3": "What happens if I lose access?",
						"q4": "Is it safe to share my VIVI-ID?"
					},
					"answer": {
						"a1": "The VIVI-ID is a unique identifier that facilitates and speeds up the delivery of your orders. By using your VIVI-ID, companies can identify you quickly, ensuring that your orders reach the correct person. To make the most of this tool, simply add your VIVI-ID at the beginning of your name when making purchases, allowing systems to confirm the orders are truly yours. Your VIVI-ID is always accessible on the home screen of your app and in your locker details, ready to be copied with a single click. It’s easy for you and everyone!",
						"a2": "The VIVI-ID is automatically assigned by the system when you create your account and identifies you as a unique locker customer. It cannot be renewed or changed.",
						"a3": "You can recover your account using your email address. Request a password reset, make the change, and you will regain access to the app, where your VIVI-ID and registered lockers will be available.",
						"a4": "Yes, it is completely safe. The VIVI-ID does not share your personal information; it only identifies you as a unique customer within the locker system. Your email is only used for status notifications and package details."
					}
				},
				"tempPassword": {
					"title": "Use of Temporary Passwords (OTP)",
					"subtitle": "Guide on OTP and its importance",
					"questions": {
						"q1": "What is a Temporary Password?",
						"q2": "How do I use my OTP?",
						"q3": "How do I register an OTP?",
						"q4": "What happens if I don’t register an OTP?",
						"q5": "What do I do if my OTP doesn’t work?"
					},
					"answer": {
						"a1": "A Temporary Password, also known as an OTP (One-Time Password), is a unique security code provided by some online stores to ensure the safe delivery of your order. This password serves to: Verify your identity as the legitimate recipient. Add an extra layer of security to your delivery. Allow you to receive orders from stores that use this security feature in our smart lockers.",
						"a2": "If you have received an OTP for your order, you can easily use it with our service by following these steps: 1. Open the Vivipost Smart Lockers app. 2. Go to the OTP menu. 3. Follow the instructions on the screen to register your OTP. Registering your OTP ensures that your order can be safely delivered to our lockers, giving you flexibility even for shipments requiring additional security.",
						"a3": "Registering your Temporary Password (OTP) is simple: 1. Open the Vivipost app. 2. In the bottom menu, find and select the OTP icon. 3. Complete the required fields: Tracking number: The number provided by the online store. Temporary password (OTP): The code you received by email. It authorizes the delivery person to leave your order in the locker. Click “Save order”. That’s it! Your OTP will now allow secure delivery without complications. Make sure to enter both the tracking number and OTP correctly to avoid delivery issues.",
						"a4": "If you don’t register an assigned OTP: 1. The locker app will offer the delivery person options to contact you (your contact information is not displayed; the courier will contact you through their platform if allowed). 2. If the delivery person reaches you and obtains the OTP, they can complete the delivery. 3. If contact is not possible, delivery will be at the courier’s discretion. We recommend always registering assigned OTPs to avoid delays or issues.",
						"a5": "The application will offer options for the delivery person to contact you (without showing your personal information) and verify the OTP with you. If contact cannot be made, delivery will depend on the courier’s policies."
					}
				},
				"receiptCollect": {
					"title": "Receiving and Collecting Orders",
					"subtitle": "Collection process, deadlines, and notifications",
					"questions": {
						"q1": "Do I need to register my orders?",
						"q2": "What happens if I don't collect my order?",
						"q3": "Can I share my pickup code?",
						"q4": "What happens if I don’t collect it on time?"
					},
					"answer": {
						"a1": "No, you generally do not need to register your orders. It is only necessary when the online store assigns you a Temporary Password (OTP). This usually applies to: Specific types of orders. High-value products. If you register the OTP in our app, it will appear to the courier when processing your order, allowing delivery without needing to contact you. Notifications are automatically sent from our system. Most orders do not require prior registration.",
						"a2": "It’s important to be aware of the collection period: You have 3 days from when the package enters the locker to pick it up. You will receive reminder notifications. If the time expires: Your order becomes 'Expired'. The administrator is notified to remove it. Your pickup code is disabled. Recovering an expired order: If the package is still inside: The administrator may provide a new code. If it has been removed: The administrator can give it to you directly. This ensures locker availability for all users.",
						"a3": "Yes, you can share your pickup code, but take into account: Generation and sending: The code is generated and sent only to your account. Responsibility: Sharing the code is entirely your responsibility. The person with the code can collect the order on your behalf. Security: Vivipost does not share this code with anyone else. Recommendation: Only share it when necessary and with trusted individuals.",
						"a4": "You have three (3) days to collect your order. After the 3 days: The order becomes 'Expired'. Your code will stop working. What to do: Visit your company/administrator to collect the order. Recommendation: Collect as soon as possible. We will send reminders so you don’t miss the deadline."
					}
				},
				"serviceCompatibility": {
					"title": "Services and Compatibility",
					"subtitle": "Information about compatibility with couriers",
					"questions": {
						"q1": "Can I receive orders from any courier?",
						"q2": "How do internal company deliveries work?"
					},
					"answer": {
						"a1": "Yes, our smart locker system is designed to be versatile and convenient. Compatibility: You can receive orders from any courier service. Internal deliveries: You can receive shipments or documents from other departments or company locations. Benefits: Avoids office-hour restrictions. Doesn’t depend on security personnel. No need for direct desk delivery. The sender can locate your locker using your VIVI-ID or name. You will receive automatic notifications when delivered.",
						"a2": "Smart Locker System for Internal Company Deliveries Our smart locker system allows convenient internal transfers of documents, sealed envelopes, or small items between company locations or departments. Any employee can use it by locating your account through your VIVI-ID or name. Advantages include: avoiding office-hour restrictions, eliminating dependency on security personnel, and enabling confidential delivery. You’ll receive automatic notifications, and only you (or someone with your code) can access the compartment. This improves communication efficiency and internal logistics."
					}
				}
			},
			"delete": {
				"title": "Delete account",
				"mainTitle": "Are you sure you want to delete your account?",
				"mainSubtitle": "This action is permanent and cannot be undone. All your data will be permanently deleted.",
				"buttons": {
					"deleted": "Delete account"
				},
				"alerts": {
					"DELETE_USER": {
						"title": "The user has been deleted",
						"subtitle": "The user has been removed. Thank you for using the Package Hub app."
					},
					"USER_WITH_PACKAGES": {
						"title": "The user was not deleted",
						"subtitle": "The user has assigned packages"
					}
				}
			}
		},
		"logout": {
			"title": "Log out"
		}
	},
	"calendar": {
		"dayNames": [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday"
		],
		"dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		"dayNamesMin": ["S", "M", "T", "W", "T", "F", "S"],
		"monthNames": [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		],
		"monthNamesShort": [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec"
		],
		"today": "Today",
		"clear": "Clear"
	},
	"navbar": {
		"welcome": "Welcome to your ",
		"home": "Home",
		"activity": "Activity",
		"preferences": "Preferences"
	},
	"tutorial": {
		"title": "How does it work?",
		"first-step": {
			"title": "Flexible and Accessible",
			"subtitle": "When your order is placed in one of our lockers, we'll send you both a QR code and a numeric code so you can collect it."
		},
		"second-step": {
			"title": "Less Than a Minute",
			"subtitle": "That's all it takes to pick up your order. Simply scan or enter your code and you're all set."
		},
		"third-step": {
			"title": "Don't Forget to Close the Door",
			"subtitle": "Our lockers are shared by everyone. Please make sure to close the door after collecting your order so we can continue providing the service."
		},
		"buttons": {
			"next": "Next",
			"finish": "Finish"
		}
	},
	"activity": {
		"title": "Activity",
		"subtitle": "Check the status of your shipments and access the details of each package.",
		"cards": {
			"card1": {
				"title": "Process"
			},
			"card2": {
				"title": "Scheduled"
			},
			"card3": {
				"title": "Completed"
			}
		}
	},
	"scheduledSection": {
		"title": "Scheduled",
		"viewAll": "View all",
		"table": {
			"service": "Service",
			"locker": "Locker",
			"status": "Status",
			"otp": "OTP",
			"favor": "Is favor",
			"scheduled": "Scheduled",
			"yes": "Yes",
			"no": "No"
		},
		"empty": {
			"title": "You don't have any scheduled services",
			"subtitle": "Once you schedule a service, it will appear here so you can easily track it."
		}
	},
	"inLockerSection": {
		"title": "In Locker",
		"viewAll": "View all",
		"table": {
			"tracking": "Tracking",
			"locker": "Locker",
			"expires": "Expires",
			"days": "Days",
			"favor": "Favor",
			"expired": "Expired",
			"daysSuffix": "days",
			"yes": "Yes",
			"no": "No"
		},
		"empty": {
			"title": "You have no packages in your locker",
			"subtitle": "When you receive a package, it will appear here so you can pick it up before it expires"
		}
	},
	"activateServicePage": {
		"title": "Activate Locker Service",
		"subtitle": "Complete your one-time payment to unlock Package Hub features including 24/7 package receiving, QR code access, and delivery scheduling.",

		"paymentMethod": {
			"title": "Payment Method",
			"creditCardTitle": "Credit Card",
			"creditCardSubtitle": "Visa, Mastercard, Amex"
		},

		"summary": {
			"title": "Order Summary"
		},

		"cta": {
			"pay": "Pay & Activate Service",
			"processing": "Processing…"
		}
	},
	"pendingPayment": {
		"title": "Service Pending Activation",
		"subtitle": "Complete your payment to schedule packages and receive deliveries in your Package Hub locker.",
		"cta": "Pay Subscription"
	},
	"activationSummary": {
		"title": "Package Hub Access",
		"subtitle": "Unlock the full power of smart locker delivery",

		"benefits": {
			"receive": "Receive packages 24/7",
			"qr": "QR code locker access",
			"schedule": "Schedule deliveries"
		},

		"badges": {
			"oneTime": "One-time payment",
			"noSubscription": "No subscription",
			"permanent": "Permanent access"
		}
	},
	"priceSummary": {
		"breakdown": {
			"serviceActivation": "Service activation"
		},
		"total": "Total",
		"taxesIncluded": "Taxes included"
	},
	"securityFooter": {
		"secureStripe": "Secure payment powered by Stripe",
		"cardNotStored": "Card details are never stored",
		"compactStripe": "Stripe Secure",
		"compactSSL": "SSL Encrypted"
	},
	"paymentForm": {
		"cardNumber": "Card Number",
		"expirationDate": "Expiration Date",
		"securityCode": "Security Code"
	},

	"expiredPackage": {
		"breadcrumb": {
			"home": "Home",
			"expired": "Expired Package"
		},
		"title": "Your package has expired",
		"subtitle": "To continue using smart locker features, complete your pending payment to restore access.",
		"status": {
			"disabled": "Access disabled",
			"folio": "Folio:"
		},
		"paymentMethod": "Payment Method",
		"summary": {
			"title": "Payment Summary",
			"subscriptionExpired": "Expired subscription",
			"taxes": "Taxes",
			"total": "Total due"
		},
		"cta": {
			"processing": "Processing…",
			"payRestore": "Pay & Restore Access"
		}
	},
	"myPackages": {
		"empty": {
			"title": "No packages",
			"subtitle": "There are no packages in this category."
		},
		"meta": {
			"date": "Date",
			"otp": "OTP",
			"pendingPayment": "Pending payment"
		}
	}
}
